import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useStoreState } from "pullstate";
import { createContext, useEffect, useState } from "react";
import Store from "../../utils/Store";
import { clone, get, isEmpty, set } from "lodash";
import useWebsocket from "../../hooks/useWebsocket";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import constants from "../../utils/constants";
import { isValidDate } from "../../utils";
import getPatients from "./services/getPatients";
import getCounts from "./services/getCounts";
import { getEmergencyPatients } from "../Settings/utils";
import { add } from "date-fns";
import getMatchingPatient from "../MatchingPatient/services/getMatchingPatient";
import { downloadFile } from "../ExportMessage/services/downloadService";
import { useRouter } from "next/router";
export var PatientsContext = /*#__PURE__*/createContext({});
export var PatientsContextProvider = function PatientsContextProvider(props) {
  var _localStorage, _localStorage2, _localStorage3;
  var children = props.children;
  var pageSize = constants.PAGE_SIZE;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        user: s.user,
        newPatientId: s.newPatientId
      };
    }),
    user = _useStoreState.user,
    newPatientId = _useStoreState.newPatientId;
  var userId = get(user, ["sub"], "");
  var isLoggedIn = !isEmpty(user);
  var _useState = useState(""),
    lastId = _useState[0],
    setLastId = _useState[1];
  var _useState2 = useState(null),
    patientsData = _useState2[0],
    setPatientsData = _useState2[1];
  var _useState3 = useState({}),
    updatedMessage = _useState3[0],
    setUpdatedMessage = _useState3[1];
  var _useState4 = useState({}),
    unreadMessages = _useState4[0],
    setUnreadMessages = _useState4[1];
  var _useState5 = useState({}),
    currentPatient = _useState5[0],
    setCurrentPatient = _useState5[1];
  var _useState6 = useState(false),
    isPatientsLoading = _useState6[0],
    setPatientsLoading = _useState6[1];
  var _useState7 = useState(0),
    count = _useState7[0],
    setCount = _useState7[1];
  var _useState8 = useState(false),
    isCountLoading = _useState8[0],
    setIsCountLoading = _useState8[1];
  var _persistedFilters = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(constants.PERSISTED.filterObj);
  var _useState9 = useState(_persistedFilters ? JSON.parse(_persistedFilters) : constants.DEEFAULT_FILTER),
    filters = _useState9[0],
    setFilters = _useState9[1];
  var _persistedSavedFilters = (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem(constants.PERSISTED.savedFilterData);
  var _useState10 = useState(_persistedSavedFilters ? JSON.parse(_persistedSavedFilters) : null),
    savedFilterData = _useState10[0],
    setSavedFilterData = _useState10[1];
  var _persistedFullWidthWorklist = (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.getItem(constants.PERSISTED.isFullWidthWorklist);
  var _useState11 = useState(!!_persistedFullWidthWorklist),
    isFullWidthWorklist = _useState11[0],
    setIsFullWidthWorklist = _useState11[1];
  var _useState12 = useState([]),
    matchingPatients = _useState12[0],
    setMatchingPatients = _useState12[1];
  var _useWebsocket = useWebsocket("/worklist/".concat(userId, "/"), !isEmpty(user)),
    socket = _useWebsocket.socket,
    wsData = _useWebsocket.wsData;
  var router = useRouter();
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var getPatientData = function getPatientData() {
    var filterParams = getFilterParams(filters);
    var params = _objectSpread({
      page_size: pageSize
    }, filterParams);
    if (lastId) {
      params.pagination_id = lastId;
    }
    setPatientsLoading(true);
    getPatients(params, patientsData).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_patientsData) {
        var _emergencyPatients, _emergencyPatientsData2, _updatedPatients;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _emergencyPatients = [];
                if (lastId) {
                  _context.next = 6;
                  break;
                }
                _context.next = 4;
                return getEmergencyPatients();
              case 4:
                _emergencyPatientsData2 = _context.sent;
                _emergencyPatients = get(_emergencyPatientsData2, ["data", "content"], []);
              case 6:
                _updatedPatients = updatePatientList(_patientsData || patientsData, _emergencyPatients);
                setPatientsData(_updatedPatients);
                setPatientsLoading(false);
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())["catch"](function (e) {
      setPatientsLoading(false);
    });
  };
  useEffect(function () {
    if (isLoggedIn) {
      getPatientData();
    }
  }, [lastId, pageSize, filters]);
  useEffect(function () {
    /* get total patient count just for display on top on worklist */
    if (isLoggedIn) {
      var _params = getFilterParams(filters);
      setIsCountLoading(true);
      getCounts(_params).then(function (_count) {
        setCount(_count);
        setIsCountLoading(false);
      })["catch"](function () {
        setCount(0);
        setIsCountLoading(false);
      });
    }
  }, [filters]);
  useEffect(function () {
    if (!isEmpty(currentPatient)) {
      var _currentPatientUid = get(currentPatient, ["patient_uid"], 0);
      findMatchingPatient(_currentPatientUid);
    }
  }, [currentPatient]);
  var getFilterParams = function getFilterParams(_filters) {
    var _filters$data;
    var filterParams = _objectSpread({}, (_filters$data = _filters === null || _filters === void 0 ? void 0 : _filters.data) !== null && _filters$data !== void 0 ? _filters$data : {});
    var startDate = get(filterParams, ["start_date"], "");
    var endDate = get(filterParams, ["end_date"], "");
    if (startDate) {
      var _startDateVal = new Date(startDate);
      var _endDateVal = add(new Date(endDate), {
        days: 1
      });
      if (isValidDate(_startDateVal) && isValidDate(_endDateVal)) {
        _startDateVal.setHours(0, 0, 0);
        _endDateVal.setHours(0, 0, 0);
        set(filterParams, ["start_date"], _startDateVal.toISOString());
        set(filterParams, ["end_date"], _endDateVal.toISOString());
      }
    }
    return filterParams;
  };
  var updatePatientUnreadCount = function updatePatientUnreadCount(currentPatientUid, hasNewMessage) {
    var patients = get(patientsData, ["data", "content"], []);
    var currentPatient = patients && patients.find(function (p) {
      return get(p, ["patient_uid"], 0) == currentPatientUid;
    });
    var count = 0;
    if (hasNewMessage) {
      count = get(currentPatient, ["unread_message_count"], 0) + 1;
    }
    if (currentPatient) {
      set(currentPatient, ["unread_message_count"], count);
    }
  };
  var getPatientsByEmergency = function getPatientsByEmergency(_patients) {
    var _emergencyPatients = _patients.filter(function (_pat) {
      return get(_pat, ["emergency", "stale"], null) === false;
    });
    var _nonEmergencyPatients = _patients.filter(function (_pat) {
      var stale = get(_pat, ["emergency", "stale"], null);
      return stale === true || stale === null;
    });
    return {
      _emergencyPatients: _emergencyPatients,
      _nonEmergencyPatients: _nonEmergencyPatients
    };
  };
  var formPatientStateObject = function formPatientStateObject(_patients, _patientsData) {
    if (_patientsData) {
      var _content = Object.assign(_patientsData, {
        data: _objectSpread(_objectSpread({}, _patientsData.data), {}, {
          content: _patients
        })
      });
      return _content;
    }
    return _patientsData;
  };
  var updatePatientList = function updatePatientList(patientsData, _emergencyPatients) {
    var patientIds = _emergencyPatients.map(function (_pat) {
      return _pat.patient_uid;
    });
    var _patientsData = clone(patientsData);
    var _patients = get(_patientsData, ["data", "content"], []);
    _patients = _patients.filter(function (_pat) {
      return !patientIds.includes(_pat.patient_uid);
    });
    _patients = [].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_patients));
    return formPatientStateObject(_patients, _patientsData);
  };
  var findMatchingPatient = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_patientUid) {
      var _matches;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_patientUid) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return getMatchingPatient(_patientUid);
            case 3:
              _matches = _context2.sent;
              setMatchingPatients(_matches);
            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function findMatchingPatient(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (wsData) {
      var _filterObj = localStorage.getItem(constants.PERSISTED.filterObj);
      var _isFilterApplied = false;
      if (_filterObj) {
        var _JSON$parse;
        _isFilterApplied = (_JSON$parse = JSON.parse(_filterObj)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.isFilterApplied;
      }
      if (wsData.action == "new_message" || wsData.action == "update_message" || wsData.action == "unsubscribe" || wsData.action == "subscribe") {
        var _unreadMessages2 = clone(unreadMessages);
        if (wsData.action == "new_message") {
          var _msgContent = get(wsData, ["content"], {});
          var _msgPatientUid = get(_msgContent, ["patient_uid"], 0);
          var _currentPatientUid2 = get(currentPatient, ["patient_uid"], 0);
          // --- Kept this code for future use ---
          // const msgsList = _unreadMessages[msgPatientUid] || []
          // msgsList.unshift(msgContent)
          set(_unreadMessages2, [_msgPatientUid], [_msgContent]); // [...msgsList]
          if (get(_msgContent, ["user"], "") !== userId && _msgPatientUid != _currentPatientUid2) {
            updatePatientUnreadCount(_msgPatientUid, true);
          }
          if ((get(_msgContent, ["image_report_uid"], 0) > 0 || get(_msgContent, ["image_study_uid"], 0) > 0) && _msgPatientUid === _currentPatientUid2) {
            Store.update(function (s) {
              s.enableViewerAPICall = false;
            });
            setTimeout(function () {
              Store.update(function (s) {
                s.enableViewerAPICall = true;
              });
            }, 500);
          }
        }
        if (wsData.action == "update_message") {
          var _msgContent2 = get(wsData, ["content"], {});
          setUpdatedMessage(_msgContent2);
        }
        if (wsData.action == "unsubscribe") {
          var _msgPatientUid2 = get(wsData, ["patient_uid"], 0);
          set(_unreadMessages2, [_msgPatientUid2], []);
        }
        if (wsData.action == "subscribe") {
          var _msgPatientUid3 = get(wsData, ["patient_uid"], 0);
          updatePatientUnreadCount(_msgPatientUid3);
        }
        setUnreadMessages(_unreadMessages2);
      }
      if (wsData.action == "new_patient" && !_isFilterApplied) {
        var _newPatient = get(wsData, ["content"], {});
        var _newPatientId2 = get(_newPatient, ["patient_id"], "");
        var _newPatientUid2 = get(_newPatient, ["patient_uid"], "");
        var _patientsData2 = clone(patientsData);
        var _patients2 = get(patientsData, ["data", "content"], []);
        var _getPatientsByEmergen = getPatientsByEmergency(_patients2),
          _emergencyPatients = _getPatientsByEmergen._emergencyPatients,
          _nonEmergencyPatients = _getPatientsByEmergen._nonEmergencyPatients;
        _nonEmergencyPatients.unshift(_newPatient);
        var _updatedPatientData = formPatientStateObject([].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_nonEmergencyPatients)), _patientsData2);
        setPatientsData(_updatedPatientData);
        // for auto selecting newly registered patient by user
        if (newPatientId && _newPatientId2 && newPatientId === _newPatientId2) {
          if (isMobile) {
            var _workList = document.getElementById("worklist-container");
            if (_workList) {
              _workList["scrollTop"] = 0;
            }
          } else {
            router.push("/patients/".concat(_newPatientUid2));
          }
          Store.update(function (s) {
            s.newPatientId = "";
          });
        }
      }
      if (wsData.action === "new_emergency" || wsData.action === "update_emergency") {
        var _newPatientEmergencyContent = get(wsData, ["content"], {});
        var _patientsData3 = clone(patientsData);
        var _patients3 = get(_patientsData3, ["data", "content"], []);
        var _patientId = get(_newPatientEmergencyContent, ["patient_id"]);
        var _stale = get(_newPatientEmergencyContent, ["stale"], false);
        if (wsData.action === "update_emergency") {
          var _selectedEmergencyPatient2 = _patients3.find(function (_pat) {
            return _pat.patient_uid === _patientId;
          });
          // _selectedEmergencyPatient =
          //   _selectedEmergencyPatient && _selectedEmergencyPatient[0];
          if (_selectedEmergencyPatient2) {
            _selectedEmergencyPatient2.emergency = _stale ? null : _newPatientEmergencyContent;
          }
          _patients3 = _patients3.filter(function (_pat) {
            return _pat.patient_uid !== _patientId;
          });
          var _getPatientsByEmergen2 = getPatientsByEmergency(_patients3),
            _emergencyPatients2 = _getPatientsByEmergen2._emergencyPatients,
            _nonEmergencyPatients2 = _getPatientsByEmergen2._nonEmergencyPatients;
          _patients3 = [].concat(_toConsumableArray(_emergencyPatients2), _toConsumableArray(_selectedEmergencyPatient2 ? [_selectedEmergencyPatient2] : []), _toConsumableArray(_nonEmergencyPatients2));
          if (currentPatient && _selectedEmergencyPatient2 && (currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === _selectedEmergencyPatient2.patient_uid) {
            setCurrentPatient(_objectSpread({}, _selectedEmergencyPatient2));
          }
        } else if (wsData.action === "new_emergency") {
          var _updatedPatient = _patients3.filter(function (_pat) {
            return _pat.patient_uid === _patientId;
          }).map(function (_pat) {
            return Object.assign(_pat, {
              emergency: _newPatientEmergencyContent
            });
          });
          _patients3 = _patients3.filter(function (_pat) {
            return _pat.patient_uid !== _patientId;
          });
          _patients3.unshift(get(_updatedPatient, [0], {}));
        }
        var _updatedPatientData3 = formPatientStateObject(_patients3, _patientsData3);
        setPatientsData(_updatedPatientData3);
      }
      if (wsData.action == "update_patient") {
        var _patientsData4 = clone(patientsData);
        var _newPatient2 = get(wsData, ["content"], {});
        var _patients4 = get(_patientsData4, ["data", "content"], []);
        var _patientToUpdateIdx = _patients4.findIndex(function (p) {
          return p.patient_uid === _newPatient2.patient_uid;
        });
        if (_patientToUpdateIdx >= 0) {
          _patients4[_patientToUpdateIdx] = _newPatient2;
          setPatientsData(_patientsData4);
          if ((currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === (_newPatient2 === null || _newPatient2 === void 0 ? void 0 : _newPatient2.patient_uid)) {
            setCurrentPatient(_newPatient2);
          }
        }
      }
      if (wsData.action === "export_download_started") {
        Store.update(function (s) {
          s.showExportUpdate = true;
          s.downloadProgress = wsData.progress;
          s.exportGenFailed = false;
        });
      }
      if (wsData.action === "export_download_progress") {
        Store.update(function (s) {
          s.isExportReady = false;
          s.exportGenFailed = false;
          s.downloadProgress = wsData.progress;
        });
      }
      if (wsData.action === "export_generation_complete") {
        Store.update(function (s) {
          s.isExportReady = true;
          s.exportGenFailed = false;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        });
        // Api call to download the Export file
        downloadFile();
      }
      if (wsData.action === "export_download_failed") {
        Store.update(function (s) {
          s.showExportUpdate = true;
          s.isExportReady = false;
          s.exportGenFailed = true;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        });
      }
    }
  }, [wsData]);
  return /*#__PURE__*/React.createElement(PatientsContext.Provider, {
    value: {
      patientsData: patientsData,
      setPatientsData: setPatientsData,
      getPatientData: getPatientData,
      updatePatientUnreadCount: updatePatientUnreadCount,
      updatedMessage: updatedMessage,
      setUpdatedMessage: setUpdatedMessage,
      unreadMessages: unreadMessages,
      setUnreadMessages: setUnreadMessages,
      currentPatient: currentPatient,
      setCurrentPatient: setCurrentPatient,
      getFilterParams: getFilterParams,
      lastId: lastId,
      setLastId: setLastId,
      isPatientsLoading: isPatientsLoading,
      setPatientsLoading: setPatientsLoading,
      filters: filters,
      setFilters: setFilters,
      count: count,
      isCountLoading: isCountLoading,
      setIsFullWidthWorklist: setIsFullWidthWorklist,
      isFullWidthWorklist: isFullWidthWorklist,
      matchingPatients: matchingPatients,
      setMatchingPatients: setMatchingPatients,
      savedFilterData: savedFilterData,
      setSavedFilterData: setSavedFilterData,
      socket: socket,
      wsData: wsData
    }
  }, children);
};